export default __webpack_public_path__ + "static/media/services1.058effd6.jpg";